export class DropdownValueObject {
  value: any;
  label: string;

  constructor(value: any, label?: string | null) {
    this.value = value;
    this.label = label ? label : value.toString();
  }
}
